import React, { useState } from 'react';
import { UserAvatar32 } from '@carbon/icons-react';
import { Button } from 'carbon-components-react';
import { phoneNumberFormatter } from 'utilities/validation';

const ProfileSummary: React.FC<Props> = ({ user }) => {
  const [useDefaultAvatar, setUseDefaultAvatar] = useState<boolean>(false);

  const handleClickUpdateProfile = () => {
    window.open(
      `${process.env.REACT_APP_IDENTITY_WEB_URL}/profile`,
      'profileNewWindow'
    );
  };

  return (
    <div id="profile-summary" className="profile-summary spacing-padding">
      <div className="sub-section-title">Profile summary</div>
      <div className="avatar-container">
        {!useDefaultAvatar ? (
          <img
            src={user.profile_pic_url}
            alt="profile"
            className="avatar-image"
            onError={() => setUseDefaultAvatar(true)}
          />
        ) : (
          <UserAvatar32 />
        )}
      </div>
      <div className="profile-info">
        <div>{`${user.first_name} ${user.last_name}`}</div>
        <div>{user.reg_email}</div>
        <div>
          {user.mobile_number &&
            phoneNumberFormatter({
              phoneNumber: user.mobile_number
            }).getNationalNumberFormat()}
        </div>
      </div>
      <div className="update-profile-button-container">
        <Button
          kind="tertiary"
          size="default"
          className="button-size"
          onClick={handleClickUpdateProfile}
        >
          Update profile
        </Button>
      </div>
    </div>
  );
};

interface Props {
  user: any;
}

export default React.memo(ProfileSummary);
